import memoize from 'memoize-one';

export default memoize(error => {
  const { code, message } = error;

  switch (code) {
    case '1001':
      return {
        code,
        message: 'error_1001',
        type: 'error',
      };
    case '1002':
      return {
        code,
        message: 'error_1002',
        type: 'error',
      };
    case '1003':
      return {
        code,
        message: 'error_1003',
        type: 'error',
      };
    case '1004':
      return {
        code,
        message: 'error_1004',
        type: 'error',
      };
    case '1005':
      return {
        code,
        message: 'error_1005',
        type: 'error',
      };
    case '1006':
      return {
        code,
        message: 'error_1006',
        type: 'error',
      };
    case '1007':
      return {
        code,
        message: 'error_1007',
        type: 'error',
      };
    case '1009':
      return {
        code,
        message: 'error_1009',
        type: 'error',
      };
    case '1010':
      return {
        code,
        message: 'error_1010',
        type: 'error',
      };
    case '1011':
      return {
        code,
        message: 'error_1011',
        type: 'error',
      };
    case '1012':
      return {
        code,
        message: 'error_1012',
        type: 'error',
      };
    case '1015':
      return {
        code,
        message: 'error_1015',
        type: 'error',
      };
    case '1016':
      return {
        code,
        message: 'error_1016',
        type: 'error',
      };
    case '1017':
      return {
        code,
        message: 'error_1017',
        type: 'error',
      };
    case '1018':
      return {
        code,
        message: 'error_1018',
        type: 'error',
      };
    case '1019':
      return {
        code,
        message: 'error_1019',
        type: 'error',
      };
    case '1021':
      return {
        code,
        message: 'error_1021',
        type: 'error',
      };
    case '1022':
      return {
        code,
        message: 'error_1022',
        type: 'error',
      };
    case '1025':
      return {
        code,
        message: 'error_1025',
        type: 'error',
      };
    case '1026':
      return {
        code,
        message: 'error_1026',
        type: 'error',
      };
    case '1027':
      return {
        code,
        message: 'error_1027',
        type: 'error',
      };
    case '1029':
      return {
        code,
        message: 'error_1029',
        type: 'error',
      };
    case '1030':
      return {
        code,
        message: 'error_1030',
        type: 'error',
      };
    case '1031':
      return {
        code,
        message: 'error_1031',
        type: 'error',
      };
    case '1032':
      return {
        code,
        message: 'error_1032',
        type: 'error',
      };
    case '1033':
      return {
        code,
        message: 'error_1033',
        type: 'error',
      };
    case '1034':
      return {
        code,
        message: 'error_1034',
        type: 'error',
      };
    case '1035':
      return {
        code,
        message: 'error_1035',
        type: 'error',
      };
    case '1036':
      return {
        code,
        message: 'error_1036',
        type: 'error',
      };
    case '1037':
      return {
        code,
        message: 'error_1037',
        type: 'error',
      };
    case '1038':
      return {
        code,
        message: 'error_1038',
        type: 'error',
      };
    case '1054':
      return {
        code,
        message: 'error_1054',
        type: 'error',
      };
    case '1101':
      return {
        code,
        message: `error_1101`,
        type: 'error',
      };
    case '1102':
      return {
        code,
        message: `error_1102`,
        type: 'error',
      };
    case '1103':
      return {
        code,
        message: `error_1103`,
        para: message,
        type: 'error',
      };
    case '1104':
      return {
        code,
        message: `error_1104`,
        type: 'error',
      };
    case '1201':
      return {
        code,
        message: `error_1201`,
        type: 'error',
      };
    case '1057':
      return {
        code,
        message: `error_1057`,
        type: 'error',
      };
    case '1058':
      return {
        code,
        message: `error_1058`,
        type: 'error',
      };
    case '1059':
      return {
        code,
        message: `error_1059`,
        type: 'error',
      };
    case '1060':
      return {
        code,
        message: `error_1060`,
        type: 'error',
      };
    case '1061':
      return {
        code,
        message: `error_1061`,
        type: 'error',
      };
    case '1062':
    case '1063':
      return {
        code,
        message: `error_1063`,
        type: 'error',
      };
    case '1066':
      return {
        code,
        message: `error_1066`,
        type: 'error',
      };
    case '1043':
      return {
        code,
        message: `error_1043`,
        type: 'error',
      };
    case '1044':
      return {
        code,
        message: `error_1044`,
        type: 'error',
      };
    case '1045':
      return {
        code,
        message: `error_1045`,
        type: 'error',
      };
    case '1046':
      return {
        code,
        message: `error_1046`,
        description: `error_1046_description`,
        type: 'error',
      };
    default:
      if (error && error.message === 'Endpoint request timed out') {
        return {
          message: 'error_default',
          type: 'error',
        };
      }
      return error;
  }
});
